import React from 'react';
import './DeleteItem.scss';
import { FaTrashAlt } from 'react-icons/fa';

interface IDeleteItemProps {
	onClick?: () => void;
}

export const DeleteItem = ({ onClick }: IDeleteItemProps): JSX.Element => {
	return (
		<div className="editItemContainer" onClick={onClick}>
			<FaTrashAlt />
		</div>
	);
};
